import { render } from "./HeroiconsSolidPlus.vue?vue&type=template&id=53fca7dc"
const script = {}

import exportComponent from "/www/yadonor/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPlus.vue"]])

export default __exports__